// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1OCdT","content":"styles_content__28L-M","checkbox":"styles_checkbox__1q8rf","checkboxLabel":"styles_checkboxLabel__1cRMm"};